module.exports = __webpack_public_path__ + "media/images/flags/PL-9f6b5df190b9b0178cf39ed31e6168b0.svg";